import { Observable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AuthenticationService } from '../auth/authentication.service';

@Injectable()
export class HttpAuthInterceptor implements HttpInterceptor {
  constructor(private readonly authService: AuthenticationService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const scopes: string[] = [environment.backendScope];

    return this.authService.getTokenRedirect(scopes).pipe(
      mergeMap((token) => {
        const authHeader = `Bearer ${token}`;
        const authrequest = request.clone({
          setHeaders: {
            Authorization: authHeader
          }
        });
        return next.handle(authrequest);
      })
    );
  }
}
